/**
 * Notification ringtone (mirrors Flutter local notification sound on foreground FCM).
 * Browsers often block Audio until a user gesture — call unlockNotificationSound once after interaction.
 */

const NOTIFICATION_SOUND_URL = `${process.env.PUBLIC_URL || ""}/sounds/mixkit-correct-answer-tone-2870.wav`;

let sharedAudio = null;
let unlockBound = false;

function getAudio() {
  if (typeof window === "undefined" || typeof Audio === "undefined") return null;
  if (!sharedAudio) {
    sharedAudio = new Audio(NOTIFICATION_SOUND_URL);
    sharedAudio.preload = "auto";
    sharedAudio.volume = 1;
  }
  return sharedAudio;
}

/** Call after a user click/keydown so later notification sounds are allowed to play. */
export function unlockNotificationSound() {
  if (unlockBound || typeof window === "undefined") return;
  unlockBound = true;

  const unlock = () => {
    const audio = getAudio();
    if (!audio) return;
    try {
      const prevVolume = audio.volume;
      audio.volume = 0;
      const playPromise = audio.play();
      const reset = () => {
        try {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = prevVolume;
        } catch (_) {}
      };
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.then(reset).catch(reset);
      } else {
        reset();
      }
    } catch (_) {}
  };

  const onInteract = () => {
    unlock();
    window.removeEventListener("pointerdown", onInteract, true);
    window.removeEventListener("keydown", onInteract, true);
  };

  window.addEventListener("pointerdown", onInteract, true);
  window.addEventListener("keydown", onInteract, true);
}

/**
 * Play the notification ringtone once.
 * Safe to call from FCM / badge handlers; failures are ignored (autoplay policy).
 */
export function playNotificationRingtone() {
  if (typeof window === "undefined") return;
  try {
    const audio = getAudio();
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  } catch (_) {}
}
